import React, { Component } from 'react'
import Modal from 'react-modal'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'
import ReactGA from 'react-ga'

class Subscribe extends Component {
  state = {
    openModal: false,
    error: false
  }

  openModal () {
    this.setState({
      openModal: true
    })
    this.props.toggleTitle()
  }

  closeModal (state = {}) {
    this.setState({
      openModal: false,
      ...state
    })
    this.props.toggleTitle()
  }

  async submit () {
    ReactGA.event({
      category: 'Subscribe',
      action: 'Clicked Link'
    })
    if (!this.state.email) {
      this.setState({
        error: 'email is required'
      })
    } else {
      try {
        const result = await this.props.subscribe(this.state.email, this.state.phone)
        if (result) {
          this.setState({
            error: '',
            success: 'Thanks for subscribing'
          })
          setTimeout(() => {
            this.closeModal({
              success: ''
            })
          }, 1000)
        }
      } catch (error) {
        this.setState({
          error: 'error occured, try again'
        })
      }
    }
  }

  render () {
    return (
      <div>
        <a className='subscribe-button' onClick={() => { this.openModal() }}>subscribe</a>
        <Modal
          ariaHideApp={false}
          className={{
            base: `subscribe-modal ${this.props.color}`,
            afterOpen: 'subscribe-modal--open',
            beforeClose: 'subscribe-modal--before-close'
          }}
          overlayClassName={{
            base: 'darken-overlay',
            afterOpen: 'darken-overlay--open',
            beforeClose: 'darken-overlay--before-close'
          }}
          onRequestClose={() => this.closeModal()}
          isOpen={this.state.openModal}
          contentLabel='Subscribe for updates'
        >
          <h2>Subscribe</h2>
          <div className='subscribe-form'>
            <div className='input-group'>
              <input type='email' validate placeholder='email' onChange={(e) => this.setState({ email: e.target.value})} />
            </div>
            <div className='input-group'>
              <input type='phone' placeholder='phone' onChange={(e) => this.setState({
                phone: e.target.value
              })} />
            </div>
            {this.state.error ? <div className='error'>{this.state.error}</div> : <div className='success'>{this.state.success}</div>}
            <a className='subscribe-button submit' onClick={() => {
              this.submit()
            }}>Submit</a>
          </div>
        </Modal>
      </div>
    )
  }
}

const addNewSubscriber = gql`
  mutation addSubscriber($email: String!, $phone: String) {
    addSubscriber(email: $email, phone: $phone)
  }
`

export default graphql(addNewSubscriber, {
  props: ({ mutate }) => ({
    subscribe: (email, phone) => {
      return mutate({ variables: {
        email,
        phone
      }})
    }
  })
})(Subscribe)



// WEBPACK FOOTER //
// ./src/components/Subscribe.js